module.exports = __webpack_public_path__ + "static/media/Juzix.467978ac.png";